export const hasDuplicates = (arr: unknown[]) => new Set(arr).size !== arr.length;
export const convertArrayToCommaSeperatedValue = (arr: string[]) => arr.join(", ").replace(/, ([^,]*)$/, " and $1");
